const fastlyHostnameMap = new Map([
  ['carvanaassetsdev.blob.core.windows.net', 'assets.fastly.zagforward.com'],
  ['carvanablobdev.blob.core.windows.net', 'blob.fastly.zagforward.com'],
  ['carvanacdndev.blob.core.windows.net', 'cdnblob.fastly.zagforward.com'],
  ['carvanaassetstest.blob.core.windows.net', 'assets.fastly.carvanatech.com'],
  ['carvanablobtest.blob.core.windows.net', 'blob.fastly.carvanatech.com'],
  ['carvanacdntest.blob.core.windows.net', 'cdnblob.fastly.carvanatech.com'],
  ['carvanaassetsprod.blob.core.windows.net', 'assets.fastly.carvana.io'],
  ['carvanablobprod.blob.core.windows.net', 'blob.fastly.carvana.io'],
  ['carvanacdnprod.blob.core.windows.net', 'cdnblob.fastly.carvana.io'],
  [
    'cvnavexgatewaydev.blob.core.windows.net',
    'vexgateway.fastly.zagforward.com'
  ],
  [
    'cvnavexgatewaytest.blob.core.windows.net',
    'vexgateway.fastly.carvanatech.com'
  ],
  ['cvnavexgateway.blob.core.windows.net', 'vexgateway.fastly.carvana.io']
]);

type Options = {
  blur?: number;
  crop?: string;
  dpr?: number;
  height?: number;
  optimize?: 'low' | 'medium' | 'high';
  quality?: number;
  width?: number;
};

export default function optimizeImage(
  originalUrl: string,
  options: Options = {}
): string {
  if (!originalUrl) return '';

  const { blur, crop, dpr, height, optimize, quality, width } = options;

  const url = new URL(originalUrl);
  url.hostname = fastlyHostnameMap.get(url.hostname) ?? url.hostname;
  if (blur) url.searchParams.set('blur', String(blur));
  if (crop) url.searchParams.set('crop', crop);
  if (dpr) url.searchParams.set('dpr', String(dpr));
  if (height) url.searchParams.set('height', String(height));
  if (optimize) url.searchParams.set('optimize', optimize);
  if (quality) url.searchParams.set('quality', String(quality));
  if (width) url.searchParams.set('width', String(width));

  return url.toString();
}
